import domReady from '@wordpress/dom-ready';
import Swiper from 'swiper';
import * as Focus from '../../../assets/scripts/common/focus';

domReady(() => {
  const carousels = document.querySelectorAll('.culinaryMenusCarousel');
  const galleries = document.querySelectorAll('.culinary-menu-popup__carousel');

  if (0 < carousels.length) {
    carousels.forEach((carousel) => {
      new Swiper(carousel, {
        slidesPerView: 1.3,
        spaceBetween: 24,
        loop: false,
        watchOverflow: true,

        scrollbar: {
          el: carousel.querySelector('.swiper-scrollbar'),
          draggable: true,
        },

        navigation: {
          prevEl: carousel.querySelector('.swiper-button-prev'),
          nextEl: carousel.querySelector('.swiper-button-next'),
        },

        breakpoints: {
          540: {
            slidesPerView: 2.4,
          },
          920: {
            slidesPerView: 3.3,
          },
          1400: {
            slidesPerView: 3.8,
          },
        },
      });
    });
  }

  if (0 < galleries.length) {
    galleries.forEach((gallery) => {
      new Swiper(gallery, {
        slidesPerView: 1.4,
        spaceBetween: 16,
        navigation: {
          prevEl: gallery.querySelector('.swiper-button-prev'),
          nextEl: gallery.querySelector('.swiper-button-next'),
        },
      });
    });
  }

  // Open popup on page load
  const currentHash = window.location.hash;
  if (currentHash) {
    const menuPopup = document.getElementById(
      'culinary-menu-' + currentHash.replace('#', '')
    );
    const menuPopupTrigger = document.querySelector(
      '.openPopupWindow[data-popup-id="culinary-menu-' +
        currentHash.replace('#', '') +
        '"]'
    );
    console.log(menuPopup);
    console.log(menuPopupTrigger);
    if (menuPopup && menuPopupTrigger) {
      console.log('has popup');
      menuPopup.classList.add('opened');
      menuPopup.setAttribute('aria-hidden', 'false');
      menuPopupTrigger.setAttribute('aria-expanded', 'true');
      document.documentElement.classList.add('lockedPosition');
      Focus.trapFocusInside(jQuery(currentHash));
    }
  }
});
